
  import { Vue, Component, Prop } from "vue-property-decorator";

  import GET_COMPANIES from "@/apollo/company/GetCompanies.gql";

  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
  import CardPagination from "@/components/card/CardPagination.vue";
  import CompanyCard from "@/components/company/CompanyCard.vue";
  import Search from "@/components/common/Search.vue";
  import SeachableList from "@/components/common/SeachableList.vue";
  import ActionsPanelWithFilters from "@/components/common/ActionsPanelWithFilters.vue";
  import SearchOnAction from "@/components/common/SearchOnAction.vue";

  import RouteNames from "@/entities/RouteNames";
  import { Company, User } from "@/generated/graphql";
  import PaginationConfig from "@/entities/PaginationConfig";
  import paginationConfig from "@/data/paginationConfig";

  @Component({
    components: {
      LoadingOverlay,
      CardPagination,
      CompanyCard,
      Search,
      SeachableList,
      ActionsPanelWithFilters,
      SearchOnAction,
    },
    apollo: {
      companies: {
        query: GET_COMPANIES,
        variables() {
          return this.companiesQuery;
        },
        update(data) {
          this.paginationConfig.total = data.total.aggregate.count;
          this.paginationConfig.loadedCount = data.companies.length;
          return data.companies;
        },
      },
    },
  })
  export default class ContractorCompanies extends Vue {
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    companies?: Company[];
    searchByCompanyName: string = "";
    searchTouched: boolean = false;

    paginationConfig: PaginationConfig = { ...paginationConfig };

    get companiesQuery(): Object {
      const { page, limit } = this.paginationConfig;
      const nextOffset = page * limit - limit;
      const params = {
        offset: nextOffset,
        limit: limit,
      };

      const conditions: any[] = [
        {
          contractors: {
            user_id: { _eq: this.currentUser.id },
            deleted: { _eq: false },
            approved: { _eq: true },
          },
        },
      ];

      if (this.searchByCompanyName.length > 0) {
        conditions.push({
          business_name: {
            _ilike: `%${this.searchByCompanyName}%`,
          },
        });
      }

      return {
        where: { _and: conditions },
        ...params,
        userId: this.currentUser.id,
      };
    }

    onSearch(value: string): void {
      if (!this.searchTouched) {
        this.searchTouched = true;
      }

      this.searchByCompanyName = value;
    }

    getCompanyAdminUserId(company: Company) {
      return company.admins[0].user_id;
    }

    message(company: Company): void {
      const recipientUserId = this.getCompanyAdminUserId(company);

      this.$router.push({
        name: RouteNames.INBOX,
        query: {
          recipientUserId,
        },
      });
    }
  }
